module.exports = __webpack_public_path__ + "img/215-falkland-islands.a8432e33.svg";